import Vue from 'vue'
import axios from 'axios'

import portList from '../config/ports'
import getUrlKey from './validate'

import authority from './authority'

// http://10.26.1.103:9008/web/common/1.0.0/product/listProducts

// axios.defaults.baseURL = '/web'
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN
// axios.defaults.headers.post['Content-Type'] = 'application/json; charset=utf-8'
// axios.defaults.timeout = 2500
// axios.defaults.withCredentials = true; // 是否允许带cookie这些
// axios.defaults.responseType = "json"; // 是否允许带cookie这些

// let webBase = 'http://doclever.cn:8090/mock/5aa0f1c9e8c992085a99fce6/api'
const AJAX = axios.create({
    timeout: 60000,
    responseType: 'json',
    withCredentials: true, // 是否允许带cookie这些
    headers: {
        'Content-Type': 'application/json; charset=utf-8'
    }
})
// POST传参序列化(添加请求拦截器)
AJAX.interceptors.request.use(
    config => {
    // 在发送请求之前做某件事
        if (config.method == 'post' || config.method == 'put' || config.method == 'delete') {
            // 序列化

            if (config.data) {
                config.data = JSON.stringify(config.data)
            }
        }

        const getKeyParams = getUrlKey.getUrlKey().appId
        const getLocalKeyParams = localStorage.getItem('keyParams')
        if (getKeyParams) {
            config.headers.appKey = getKeyParams
            localStorage.setItem('keyParams', getKeyParams)
        } else if (getLocalKeyParams) {
            config.headers.appKey = getLocalKeyParams
        } else {
            config.headers.appKey = 'test_report-portal'
        }

        let token = localStorage.getItem('token')
        if (token) {
            config.headers.Authorization = 'Bearer ' + token
        }

        if (config.url.indexOf('?blob') !== -1) {
            config.responseType = 'blob'
        } else if (config.url.indexOf('?arraybuffer') !== -1) {
            config.responseType = 'arraybuffer'
        } else {
            config.responseType = 'json'
        }
        return config
    },
    error => {
        console.log(`发送请求错误！${error}`)
    }
)

// 返回状态判断(添加响应拦截器)
AJAX.interceptors.response.use(

    res => {
    // 对响应数据做些事
        let data = res
        const keyParams = localStorage.getItem('keyParams')
        
        if (res.status == 200) {
            // console.log(res);
            if (res.data.code == '-501' || res.data.code == '504' || res.data.code == '503') {
                if (keyParams) {
                    window.location.href = location.protocol + '//' + location.host + '/login.html#/?appId=' + keyParams
                    localStorage.removeItem('keyParams')
                } else {
                    window.location.href = location.protocol + '//' + location.host + '/login.html#/'
                }

                let token = localStorage.getItem('token')
                if (token) {
                    localStorage.removeItem('token')
                    localStorage.removeItem('user')
                    localStorage.removeItem('permissionCodeList')
                }
            }
            if (res.data.code == '-403') {
                window.location.href = location.protocol + '//' + location.host + '/404.html'
            }
            data = res.data
        } else {
            console.log('接口出错了,请找周立臣')
        }

        if (res.status == '501' || res.status == '504' || res.status == '503') {
            if (keyParams) {
                window.location.href = location.protocol + '//' + location.host + '/login.html#/?appId=' + keyParams
                localStorage.removeItem('keyParams')
            } else {
                window.location.href = location.protocol + '//' + location.host + '/login.html#/'
            }
        }
        return data
    },
    error => {
        return Promise.reject(error)
    }
)

// ----------------初始化API实例-----------------------
let API = {}

function run (note) {
    if (typeof note === 'function') {
        return note
    }

    // 组装地址
    let gate = note.gate == undefined ? portList.gate : note.gate
    let module = note.module == undefined ? portList.module : note.module
    let version = note.version == undefined ? portList.version : note.version
    let url = ''
    let type = (note.type || 'post').toLocaleLowerCase()
    let key = portList.key || note.key

    if (gate) {
        if (gate == '/') {
            url += ''
        } else {
            url += '/' + gate
        }
    }
    if (module) {
        if (module == '/') {
            url += ''
        } else {
            url += '/' + module
        }
    }
    if (version) {
        if (version == '/') {
            url += ''
        } else {
            url += '/' + version
        }
    }

    url += (typeof note.url === 'function') ? note.url() : note.url

    if (key) {
        url += '?' + key
    }

    return function (da, fn) {
    // console.log('----------------------')
    // console.log('访问了：' + url)
    // console.log('传递参数为：')
    // console.log(da)
    // console.log(type)

        let re = AJAX
        if (type == 'post') {
            re = new Promise((resolve, reject) => {
                AJAX.post(url, da).then(res => {
                    resolve(typeof note.filter === 'function' ? note.filter(res) : res)
                }, err => {
                    reject(err)
                })
            })
            // re = AJAX.post(url, da)
        }
        if (type == 'get') {
            re = new Promise((resolve, reject) => {
                AJAX.get(url, { params: da }).then(res => {
                    resolve(typeof note.filter === 'function' ? note.filter(res) : res)
                }, err => {
                    reject(err)
                })
            })
            // re = AJAX.get(url, da)
        }
        if (type == 'put') {
            re = new Promise((resolve, reject) => {
                AJAX.put(url, da).then(res => {
                    resolve(typeof note.filter === 'function' ? note.filter(res) : res)
                }, err => {
                    reject(err)
                })
            })
            // re = AJAX.put(url, da)
        }
        return re
    }
}

for (let p in portList.list) {
    API[p] = {}
    for (let l in portList.list[p]) {
        API[p][l] = run(portList.list[p][l])
    }
}
API.host='http://www.shxda156.cn';
API.init = function (yes, no) {
    let token = window.localStorage.getItem('token')
    if (token) {
        if (typeof yes === 'string') {
            window.location.href = yes
            return
        }
        if (typeof yes === 'function') {
            yes()
        }
    } else {
        if (typeof no === 'string') {
            window.location.href = no
            return
        }
        if (typeof no === 'function') {
            no()
        }
    }
}

/* ---------------------初始化默认参数----------------------- */

// 对axios的实例重新封装成一个plugin ,方便 Vue.use(xxxx)
export default {
    install: function (Vue, Option) {
        Object.defineProperty(Vue.prototype, 'API', {
            value: API
        })
    },
    init: API.init
}

// 下载Excel
Vue.prototype.$download = function (data, name) {
    let eleLink = document.createElement('a')
    eleLink.download = `${name}.xlsx`
    eleLink.style.display = 'none'
    // 字符内容转变成blob地址
    let blob = new Blob([data])
    eleLink.href = URL.createObjectURL(blob)
    // 触发点击
    document.body.appendChild(eleLink)
    eleLink.click()
    // 然后移除
    document.body.removeChild(eleLink)
}

Vue.prototype.$exportPdf = function (data, name) {
    let eleLink = document.createElement('a')
    eleLink.download = name
    eleLink.style.display = 'none'
    let blob = new Blob([data], {
        type: 'application/pdf' // word文档为msword,pdf文档为pdf
    })
    eleLink.href = URL.createObjectURL(blob)
    // 触发点击
    document.body.appendChild(eleLink)
    eleLink.click()
    // 然后移除
    document.body.removeChild(eleLink)
}

Vue.prototype.$openUrl = function (data) {
    let eleLink = document.createElement('a')
    // eleLink.download = name
    eleLink.target='_blank'
    eleLink.style.display = 'none'
    // let blob = new Blob([data], {
    //     type: 'application/pdf' // word文档为msword,pdf文档为pdf
    // })
    eleLink.href = data
    // 触发点击
    document.body.appendChild(eleLink)
    eleLink.click()
    // 然后移除
    document.body.removeChild(eleLink)
}